import { connect } from 'react-redux';
import {
  getDocsList,
  getDocTypes,
  getCownerTypes,
  getYearsTypes,
  getFilesList,
  clearDocuments,
} from '../../actions/document';
import DocumentList from '../../components/document/List';
import { itemsOnPage } from '../../utils/const';

// Массив и счётчик приходят из стора отдельными полями, число страниц считается здесь
const mapStateToProps = ({ document }) => ({
  list: document.list,
  totalCount: document.count,
  pagesCount: Math.ceil((document.count || 0) / itemsOnPage),
  isLoading: document.isLoading,
  errorStatus: document.errorStatus,

  docTypes: document.docTypes,
  counerType: document.counerType,
  yearsType: document.yearsType,

  filesList: document.filesList,
  filesIsLoading: document.filesIsLoading,
  filesErrorStatus: document.filesErrorStatus,
});

const mapDispatchToProps = dispatch => ({
  getDocsList: (page, filters) => dispatch(getDocsList(page, filters)),
  getDocTypes: () => dispatch(getDocTypes()),
  getCownerTypes: () => dispatch(getCownerTypes()),
  getYearsTypes: () => dispatch(getYearsTypes()),
  getFilesList: (mid, djid) => dispatch(getFilesList(mid, djid)),
  clearDocuments: () => dispatch(clearDocuments()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentList);
